import { type AppIconName, getAppIconComponent } from './app-icon-mapper';
import {
  type CountryFlagIconName,
  getCountryFlagIconComponent,
} from './country-flag-icon-mapper';
import { IconName } from './Icon.interface';

export function getIconComponent(name: IconName) {
  if (name.startsWith('flag-')) {
    return getCountryFlagIconComponent(name as CountryFlagIconName);
  }

  return getAppIconComponent(name as AppIconName);
}
